import * as actions from './actions';

export default {
  settings: actions.getSettings,
};